import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

import { currencyFormat } from "@lib/text.helpers";

import {
  EMERGENCY_BUDGET_CODE,
  EMERGENCY_BUDGET_DESCRIPTIONS,
} from "../constants";

import "./budget-category-option.item.scss";

export const BudgetCategoryOptionItem = ({
  categoryOption,
  onEdit,
  canEdit,
}) => {
  const { category, option } = categoryOption;

  return (
    <div className="budget-category-option-item">
      <div className="budget-category-option-item-content">
        <span className="budget-category-option-item-content-label">
          {category?.label}
        </span>
        <span className="budget-category-option-item-content-amount">
          {category?.code === EMERGENCY_BUDGET_CODE
            ? `${EMERGENCY_BUDGET_DESCRIPTIONS[option?.label]} (${currencyFormat(option?.amount)}/one time)`
            : `${option?.label} (${currencyFormat(option?.amount)}/mo)`}
        </span>
      </div>
      {canEdit && (
        <button className="budget-category-option-item-edit" onClick={onEdit}>
          <FontAwesomeIcon icon={["fa-regular", "fa-pen-to-square"]} />
        </button>
      )}
    </div>
  );
};

BudgetCategoryOptionItem.propTypes = {
  canEdit: PropTypes.bool,
  categoryOption: PropTypes.shape({
    category: PropTypes.shape({
      code: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
    option: PropTypes.shape({
      label: PropTypes.string,
      amount: PropTypes.number,
    }).isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
};
